export const APP_VERSION_HEADER = 'x-worldcoo-app-version';
export const APP_VERSION_STORAGE_KEY = 'worldcoo:app-version';
